import { createFileRoute } from "@tanstack/react-router";

import { NotFound } from "../../shell/NotFound";

/* An address the console does not have is a wrong address: one answer, the typed
 * not-found. Old spellings are not carried forward. */
export const Route = createFileRoute("/_console/$")({
  component: NotFound,
});
